import http from '../common/api';
import {ApiSettings} from "application";

const getRequest = async (reportId) => {
  return await http.get(ApiSettings.getRequest(reportId));
}

export default getRequest;
